/** * @Author: liujiannan * @Date: 2020-09-08 15:30:52 * @Description:
预约模块按科室选择列表 */
<template>
  <div class="appointment-type-list-department">
    <div
      v-for="(item, index) in list"
      :key="index"
      @click="goToDoctorList(item)"
      class="appointment-type-list-department-item"
    >
      <div class="appointment-type-list-department-item-title">
        <div>{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    qrtype: {
      type: String,
      default: "1",
    },
    sign: {
      type: String,
      default: "",
    },
  },
  methods: {
    goToDoctorList(item) {
      console.log("item.address", item.address);
      if (item.address) {
        window.localStorage.setItem("cargo", item.address);
      } else if (item.address === "") {
        window.localStorage.setItem("cargo", item.address);
      } else {
        // window.localStorage.setItem("cargo", "");
      }
      if (item.flag === "N") {
        this.$router.push({
          name: "appointment-schedule-department",
          query: {
            ...item,
            type: "department",
            qrtype: this.qrtype,
          },
        });
      } else {
        this.$router.push({
          name: "secondary-department-list",
          query: {
            appointOfficeCode: item.id,
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.appointment-type-list-department {
  width: 100%;
  &-item {
    align-items: center;
    float: left;
    width: calc(50% - 5px);
    font-size: 0.9rem;
    text-align: center;
    &-title {
      display: flex;
      align-items: center;
      height: 3rem;
      margin: 5px;
      background-color: #fff;
      border: solid 1px #dcdcdc;
      border-radius: 0.3rem;
      div {
        width: 100%;
        line-height: 1rem;
        vertical-align: middle;
      }
    }
  }
}
</style>
